import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../../../store";
import * as httpClient from "../../../../util/httpClient";
import { Notification } from "../../../common/Notification";
import * as MyAccountActions from "../../../../store/myAccount/actions";
import { useForm } from "react-hook-form";
import i18nService from "../../../../util/Internationalization/i18n/i18n";
import moment from "moment-timezone";
import { myAccountServiceStatePII } from "../../../../store/common";
import * as services from "../../../../store/service";
import { PATTERNS } from "../../../../util/patterns";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const MembershipInformation = (props: any) => {
    const { t: tLang } = useTranslation();
    const dispatch = useDispatch();
    const businessInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._businessInformation
                : null
            : null
    );
    const getAccountInformation = (forceReload?: boolean) => dispatch(MyAccountActions.actionCreators.getAccountInformation(forceReload));
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const personalAccountInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._personalAccountInformation
                : null
            : null
    );
    const contactPreference = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._contactPreference
                : null
            : null
    );
    const [showEdit, setShowEdit] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [errorMsg, seterrorMsg] = useState("");
    const [hasEmailError, setEmailHasError] = useState(false);
    const [zipCode, setZipCode] = useState(i18nService.get("ZipCode"));

    const [piiState, setPiiState] = useState({} as myAccountServiceStatePII);

    const countryChangeDetected = () => {
        i18nService.setRegionBasedonCountry(watch("country"));
        setZipCode(i18nService.get("ZipCode"));
        setValue("city", "");
        setValue("zipCode", "");
        if (watch("country") !== "US" && watch("country") !== "CA") {
            setValue("state", "");
        } else {
            setValue("state", "---");
        }
    };

    /**Validation with react-hook-form ***/
    const { register, errors, formState, handleSubmit, watch, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const { isSubmitting } = formState;

    const showEditForm = () => {
        setShowEdit(true);
    };

    const hideEditForm = () => {
        setValue("country", accountInfo ? accountInfo.country : "US");
        countryChangeDetected();
        setShowEdit(false);
    };

    const save = (accountInformation: any) => {
        if (accountInformation && contactPreference && personalAccountInformation && accountInfo && businessInformation) {
            const requestBody = {
                FirstName: accountInformation.firstName,
                LastName: accountInformation.lastName,
                MiddleName: accountInformation.middleInitial,

                Email: personalAccountInformation.primaryEmail,
                Phone: personalAccountInformation.primaryPhone,
                PersonalSMS: contactPreference.smsNumber
                    ? getCountryInfo()
                        ? contactPreference.smsNumber.replace(/[^0-9+]/g, "")
                        : contactPreference.smsNumber
                    : contactPreference.smsNumber,
                IsEmailIdentityNotificationOptOut: contactPreference.idCrimeAndBreachNews,
                IsEmailNotificationOptOut: contactPreference.alertNotification,
                IsPushNotificationOptOut: contactPreference.appPushNotification,
                IsSmsNotificationOptOut: contactPreference.textSMSNotification,
                Address1: accountInfo.address1,
                Address2: accountInfo.address2,
                City: accountInfo.city,
                State: accountInfo.state,
                Country: accountInfo.country,
                ZipCode: accountInfo.zipCode,
                BusinessName: businessInformation.businessName,
                EIN: piiState?._businessInformation?.ein,
                FAX: businessInformation.fax,
                UserName: accountInformation.userName,
            };

            setisLoading(true);
            setEmailHasError(false);

            httpClient
                .sendRequest("POST", "api/accountInfo/saveContactInformation", requestBody)
                .then((data) => {
                    setisLoading(false);
                    if (data.isSuccess) {
                        Notification({
                            type: "success",
                            title: tLang("manageAccount.myAccount.membershipInformation.notification.titleSuccess"),
                            message: tLang("manageAccount.myAccount.membershipInformation.notification.updatedMsg"),
                        });
                        getAccountInformation(true);
                        setShowEdit(false);
                    } else if (data.hasError && data.errors.length > 0) {
                        const index = data.errors.findIndex((x: any) => x === "Email id already exists");
                        if (index > -1) {
                            seterrorMsg(data.errors[index]);
                            setEmailHasError(true);
                        }
                    }
                })
                .catch(function (error) {
                    setisLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: error,
                        duration: 0,
                    });
                });
        }
    };

    const getCountryInfo = () => {
        let currentCountry = accountInfo && accountInfo.country ? accountInfo.country : "";
        let country = watch("country") ? watch("country") : "";

        if ((currentCountry.includes("US") || currentCountry.includes("CA")) && !country) {
            return false;
        } else if (country.includes("US") || country.includes("CA")) {
            return false;
        } else {
            return true;
        }
    };

    const getAccountCreateDate = () => {
        const createdDate: string = accountInfo && accountInfo.accountCreationDate ? accountInfo.accountCreationDate : "";
        if (!createdDate) return "";
        const isUSCountry = i18nService.get("Country") === "US";
        const formatedCreatedDate: string = isUSCountry ? moment(createdDate).format("MMM D YYYY") : moment(createdDate).format("D MMM YYYY");
        return formatedCreatedDate;
    };

    const ensureDataFetched = () => {
        setisLoading(true);

        services.GetAccountInformation().then((accountInfoResponse) => {
            setisLoading(false);
            setPiiState({
                memberShipNumber: accountInfoResponse._unifiedAccountInfo.memberShipNumber,
                _businessInformation: { ein: accountInfoResponse._unifiedAccountInfo._businessInformation.ein },
            });
        });
    };

    useEffect(ensureDataFetched, []);

    return (
        <React.Fragment>
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <em className="las la-lock"></em>
                        </div>
                        <div className="box-title-text has-actions">
                            <h2 className="box-title">{tLang("manageAccount.myAccount.membershipInformation.title")}</h2>
                        </div>
                    </div>
                    {!showEdit && (
                        <div className="box-actions">
                            <button type="button" className="btn-default btn-grey-dot" id="business-account-info" onClick={() => showEditForm()}>
                                <span className="btn-text">
                                    {tLang("manageAccount.myAccount.membershipInformation.editButtonText")}{" "}
                                    <span className="sr-only">{tLang("manageAccount.myAccount.membershipInformation.title")}</span>
                                </span>
                                <span className="btn-icon">
                                    <RenderIcons iconName="pen" />
                                </span>
                            </button>
                        </div>
                    )}
                </div>
                <div className={isLoading ? "box-content loading" : "box-content"}>
                    {!showEdit && accountInfo && personalAccountInformation && (
                        <div role="grid" className="data-grid " id="business-account-info-grid" aria-hidden="false">
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-full-name-display">
                                        {tLang("manageAccount.myAccount.membershipInformation.label.name")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-full-name-display">
                                    <div className="data-value">
                                        {personalAccountInformation.firstName +
                                            " " +
                                            personalAccountInformation.middleInitial +
                                            " " +
                                            personalAccountInformation.lastName}
                                    </div>
                                </div>
                            </div>
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-member-id-display">
                                        {tLang("manageAccount.myAccount.membershipInformation.label.membershipNumber")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-member-id-display">
                                    <div className="data-value">
                                        {piiState.memberShipNumber}
                                    </div>
                                </div>
                            </div>
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-creation-date-display">
                                        {tLang("manageAccount.myAccount.membershipInformation.label.accountCreationDate")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-creation-date-display">
                                    <div className="data-value">
                                        {getAccountCreateDate()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {showEdit && personalAccountInformation && accountInfo && (
                        <div id="business-account-membership-info-form">
                            <form id="business-account-membership-info-form-container" onSubmit={handleSubmit(save)}>
                                <div className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label"> <label htmlFor="label-first-name">
                                                {tLang("manageAccount.myAccount.membershipInformation.label.fullName")}{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span></label>
                                            </legend>
                                        </div>

                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["firstName"] ? "form-row row status-error" : "form-row row"} role="alert">
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-first-name-1">
                                                                    First Name{" "}
                                                                    <span className="required" title="Mandatory">
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-first-name"
                                                                    name="firstName"
                                                                    placeholder={tLang("manageAccount.myAccount.membershipInformation.placeholder.firstName")}
                                                                    maxLength={30}
                                                                    defaultValue={personalAccountInformation.firstName}
                                                                    ref={register({ pattern: PATTERNS.FIRSTNAME.pattern, required: true })}
                                                                    aria-required="true"
                                                                />
                                                                {errors.firstName && errors.firstName.type === "pattern" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.myAccount.membershipInformation.validation.firstName.invalid")}
                                                                    </span>
                                                                )}
                                                                {errors.firstName && errors.firstName.type === "required" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.myAccount.membershipInformation.validation.firstName.required")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["middleInitial"] ? "form-row row status-error" : "form-row row"} role="alert">
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-middle-name">Middle Initial</label>
                                                            </div>
                                                            <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-middle-name"
                                                                    name="middleInitial"
                                                                    placeholder={tLang("manageAccount.myAccount.membershipInformation.placeholder.middleInitial")}
                                                                    defaultValue={personalAccountInformation.middleInitial}
                                                                    maxLength={1}
                                                                    ref={register({
                                                                        pattern: PATTERNS.MIDDLE_INITIAL.pattern,
                                                                    })}
                                                                />
                                                                {errors.middleInitial && errors.middleInitial.type === "pattern" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.myAccount.membershipInformation.validation.middleInitial.invalid")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["lastName"] ? "form-row row status-error" : "form-row row"} role="alert">
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-last-name">
                                                                    Last Name{" "}
                                                                    <span className="required" title="Mandatory">
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-last-name"
                                                                    placeholder={tLang("manageAccount.myAccount.membershipInformation.placeholder.lastName")}
                                                                    name="lastName"
                                                                    defaultValue={personalAccountInformation.lastName}
                                                                    ref={register({
                                                                        required: true,
                                                                        pattern: PATTERNS.LASTNAME.pattern,
                                                                    })}
                                                                    maxLength={30}
                                                                    aria-required="true"
                                                                />
                                                                {errors.lastName && errors.lastName.type === "pattern" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.myAccount.membershipInformation.validation.lastName.invalid")}
                                                                    </span>
                                                                )}
                                                                {errors.lastName && errors.lastName.type === "required" && (
                                                                    <span className="form-error">
                                                                        {tLang("manageAccount.myAccount.membershipInformation.validation.lastName.required")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="margin-vertical-l"></div>

                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <ul className="list-inline list-reset">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-link btn-no-padding btn-no-border btn-min-width"
                                                    onClick={() => hideEditForm()}
                                                >
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.membershipInformation.cancelButtonText")}</span>
                                                </button>
                                            </li>
                                            <li className="margin-left-s">
                                                <button type="submit" className="btn-default btn-primary btn-min-width" disabled={isSubmitting}>
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.membershipInformation.saveButtonText")}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default MembershipInformation;
